// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatCPF = (value) => {
  const replacedValue = value.replace(/[^\d]/g, '')

  if (replacedValue.length === 11) {
    return replacedValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  }
  return value
}
